import React from "react";
import { Bank, DocumentDownload } from "iconsax-reactjs";

export default function MoreDropdown({ onAccountDetails, onGenerateStatement }) {
    return (
        <div className="absolute right-0 -top-4 mt-2 w-72 bg-white shadow-md rounded-xl py-2 z-30">
            {/* Account details (clickable) */}
            <div
                onClick={onAccountDetails}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-[#101828] hover:bg-gray-100 cursor-pointer"
            >
                <Bank size="20" color="#6F00FF" variant="Bold" />
                Account details
            </div>

            {/* Generate statement (disabled) */}
            <div
                onClick={onGenerateStatement}
                className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-[#101828] hover:bg-gray-100 cursor-pointer"
            >
                <DocumentDownload size="20" color="#6F00FF" variant="Bold" />
                Generate statement
            </div>
        </div>
    );
}
